import gql from 'graphql-tag';

export const NOT_UPDATED_USER_DAYS = gql`
  query systemNotUpdatedUserDays {
    systemNotUpdatedUserDays
  }
`;
